module.exports = __webpack_public_path__ + "assets/img/gameTip.67e028bd.png";